import React, { Component } from 'react';
import Global from '../../../Global';
import FooterAbout from './FooterAbout';
import FooterQuickLinks from './FooterQuickLinks';
import FooterContact from './FooterContact';
import FooterSocialConnect from './FooterSocialConnect';
import FooterAppLinks from './FooterAppLinks';
import FooterLinks from './FooterLinks';
class Footer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      footerData: {}
    };
  }

  componentWillMount() {
    var url = Global.getAPI('footer');
    var self = this;
    fetch(url)
      .then(function (response) {
        if (response.status >= 400) {
          throw new Error("Error API: footer");
        }
        return response.json();
      })
      .then(function (data) {
        self.setState({
          footerData: data
        });
      });
  }

  render() {
    if (Object.keys(this.state.footerData).length === 0) {
      return false;
    } else {
      return (
        <footer className="footer">
          <div className="container">

            <div className="footer-upper-container">
              <nav className="row footer-directory-list">
                <FooterAbout data={ this.state.footerData.about } />
                <FooterQuickLinks data={ this.state.footerData.quickLinks } />
                <FooterContact data={ this.state.footerData.contact } />
                <div className="col-xs-12 col-md-4">
                  <FooterSocialConnect data={ this.state.footerData.socialConnect } />
                  <FooterAppLinks data={ this.state.footerData.appLinks } />
                </div>
              </nav>

              <div
                data-nosnippet
                className={"footer-rich-text"}
                dangerouslySetInnerHTML={{ __html: this.state.footerData.richText || "" }}
              />
            </div>

            <FooterLinks data={ this.state.footerData.footerLinks } />
          </div>
        </footer>
      )
    }
  }
}

export default Footer;